import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';
import WaveDivider from '../components/WaveDivider';

export default function OmMigPage() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <SEO
        title="Om mig | JT transportsejlads"
        description="Lad mig klare opgaven for dig Hos tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til det ene eller det andet, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, ... Læs Mere"
        ogTitle="Om mig | JT transportsejlads"
        ogDescription="Lad mig klare opgaven for dig Hos tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til det ene eller det andet, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, ... Læs Mere"
        ogImage="https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg"
      />

      {/* Page Header */}
      <section className="relative bg-maritime-950 text-white pt-32 pb-20 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-45">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg"
            alt="Fortøjningsreb bundet til en klampe på båddæk"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-maritime-950 via-maritime-950/80 to-maritime-950/60" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white mb-6">
            Om mig
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto">
            Passioneret sejler, uddannet skipper og mange års praktisk erfaring på det danske hav.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href="tel:+4550510062"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">+45 50 51 00 62</span>
            </a>
            <a
              href="mailto:johann2@hotmail.com"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15 text-white border border-white/20 whitespace-nowrap transition-colors"
            >
              <i className="fa-solid fa-envelope text-cyan-400" aria-hidden="true" />
              <span className="whitespace-nowrap font-medium">johann2@hotmail.com</span>
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 inset-x-0">
          <WaveDivider fill="#f8fafc" />
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-16 sm:py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Section: Lad mig klare opgaven for dig */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80 space-y-6">
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
              Lad mig klare opgaven for dig
            </h2>

            <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
              Hos JT transportsejlads tilbyder jeg en bred vifte af opgaver – store som små. Uanset om du skal have hjælp til det ene eller det andet, stræber jeg altid efter at finde den bedste løsning til netop dig. Finder du ikke netop det, som du skal have hjælp til beskrevet her, så kontakt mig endelig.
            </p>
          </div>

          {/* Section: Mere om mig with image */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80">
            <div className="md:col-span-5">
              <div className="rounded-xl overflow-hidden aspect-[4/3] bg-slate-100 shadow-md">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg"
                  alt="Hvid motorbåd der sejler i høj fart på blåt hav"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="600"
                  height="450"
                />
              </div>
            </div>

            <div className="md:col-span-7 space-y-4">
              <h3 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
                Mere om mig
              </h3>
              <p className="text-slate-700 text-base leading-relaxed">
                Jeg opnåede duelighedsbevis i 2006 som et solidt grundlag for mine maritime kompetencer, og i 2012 videreuddannede jeg mig til skipper. Siden da har jeg løbende opbygget erfaring og viden inden for sejlads, navigation og sikkerhed til søs, hvilket har styrket min faglige ballast og ansvar som fører af fartøjer.
              </p>
            </div>
          </div>

          {/* Section: Grundig kommunikation fra start */}
          <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-sm border border-slate-200/80 space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
              Grundig kommunikation fra start
            </h3>
            <p className="text-slate-700 text-base leading-relaxed">
              Jeg har stor forståelse for, at mine kunders behov og ønsker kan variere, så jeg tager altid en indledende snak med dig omkring netop dette. På den måde kan jeg bedst muligt nå i mål med leveringen af en komplet og skræddersyet løsning. Jeg spørger grundigt ind til dine forventninger til opgaven, så vi undgår misforståelser. Jeg holder dig også gerne opdateret fra start til slut, hvis du ønsker det. Det er vigtigt for mig, at mine kunder føler sig trygge gennem hele forløbet.
            </p>
          </div>

          {/* Callout: Vil du vide mere? */}
          <div className="bg-maritime-900 text-white rounded-2xl p-8 sm:p-10 shadow-xl border border-maritime-800 space-y-4">
            <h4 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
              Vil du vide mere?
            </h4>
            <p className="text-slate-200 text-base leading-relaxed">
              Finder du ikke nok informationer om din ønskede opgave her på hjemmesiden, er du altid meget velkommen til at kontakte mig til en uforpligtende snak og eventuelt et tilbud på <Link to="/" className="text-cyan-400 underline font-medium hover:text-cyan-300">bådtransport</Link> eller andet.
            </p>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
              Ring til mig på telefon <a href="tel:+4550510062" className="text-cyan-400 font-bold hover:underline whitespace-nowrap">+45 50 51 00 62</a> eller send en mail til <a href="mailto:johann2@hotmail.com" className="text-cyan-400 font-bold hover:underline whitespace-nowrap">johann2@hotmail.com</a>. Jeg besvarer din henvendelse hurtigst muligt.
            </p>
            <div className="pt-4 flex flex-wrap gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm transition-colors shadow-md"
              >
                <span>Kontakt mig nu</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Connected CMS Galleri */}
      <GallerySection
        gallerySlug="om-mig-galleri"
        title="Billeder & Maritim erfaring"
        subtitle="Erfaring på vandet med duelighedsbevis og skipperuddannelse"
      />
    </div>
  );
}
